export default __webpack_public_path__ + "static/joko-app-screenshot-home-en-71818b003e70278213823e1a6533c7a1.png";